import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

// Mixins / Modules
import isResizable from '../../../../mixins/resizable';
import Window from '../../../../../modules/window';

// Models
import Query from '@/models/query';

// Base
import Button from '../../../../v5/base/button';
import Separator from '../../../../v5/base/separator';

// Form
import Input from '../../../../v5/form/input';

class ForgotPassword extends React.Component {
  static propTypes = {
    onSetView: PropTypes.func.isRequired,
  }

  state = {
    sending: false,
    user: {
      email: '',
    },
    errorMessages: {},
  }

  handleInputChange = (field, value) => {
    const { user } =
      this.state;

    const newUser = update(
      user,
      {
        [field]: {
          $set: value,
        },
      }
    );

    this.setState({
      user: newUser,
    });
  }

  handleSubmit = (e) => {
    const { onSetView } =
      this.props;

    const {
      sending,
      user,
    } = this.state;

    e && e.preventDefault();

    if (sending) return;

    this.setState(
      {
        sending: true,
      },
      () => {
        Query
          .request(
            '/users/password',
            {
              method: 'POST',
              form: {
                user: {
                  email: user.email,
                },
              },
            }
          )
          .then(() => {
            Window.flash.success(
              'You will receive an email with instructions on how to reset your password in a few minutes.'
            );

            setTimeout(
              () =>
                onSetView(
                  'sign_in'
                ),
              2000
            );
          })
          .catch(
            ({
              responseJSON,
            }) => {
              this.setState({
                errorMessages:
                  (
                    responseJSON ||
                    {}
                  ).errors ||
                  {},
                sending: false,
              });
            }
          );
      }
    );
  }

  render() {
    const { onSetView } =
      this.props;

    const {
      user,
      errorMessages,
      sending,
    } = this.state;

    return (
      <React.Fragment>
        <div className='width-560 margin-center'>
          <img
            src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/layout/nav_logo.png`}
            className='height-28 margin-top-50 margin-bottom-25'
          />

          <div className='margin-bottom-10 xlg-font semi-bold line-height-26'>
            Forgot Password
          </div>

          <Separator className='margin-top-0 margin-bottom-30' />

          <div className='width-520'>
            <form onSubmit={this.handleSubmit}>
              <div>
                <Input
                  id='user_email'
                  label='Email address'
                  type='email'
                  errorMessage={errorMessages.email}
                  onChange={
                    (_, value) =>
                      this.handleInputChange(
                        'email',
                        value
                      )
                  }
                  defaultValue={user.email}
                />
              </div>

              <div>
                <Button
                  id='send_password_link'
                  text='Send Reset Instructions'
                  onClick={this.handleSubmit}
                  className='height-48 med-font vertical-align line-height-45'
                  disabled={sending}
                  block
                />
              </div>

              <div className='margin-top-30 sm-font'>
                Already a member?{' '}

                <Button
                  className='sm-font margin-top-30 underline'
                  text='Log in'
                  size='custom'
                  onClick={
                    () =>
                      onSetView(
                        'sign_in'
                      )
                  }
                />
              </div>

              <button
                type='submit'
                className='hide'
              />
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default isResizable(
  ForgotPassword
);
